import { AfterViewInit, Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormGroupDirective } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, NavigationEnd, NavigationStart, Router } from '@angular/router';
import { AuthHelper, AuthUser, Menu } from '@messaia/cdk';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { environment } from '../../environments/environment';

@Component({
	selector: 'app-main',
	templateUrl: './main.component.html',
	providers: [FormGroupDirective]
})
export class MainComponent implements OnInit, AfterViewInit {
	/**
	 * Page title
	 */
	public title: string;

	/**
	 * Copyright
	 */
	public copyright: string = environment.copyright;

	/**
	 * Page title
	 */
	public loaded: boolean;

	/**
	 * Menu items
	 */
	public menu: Array<Menu>;

	/**
	 * User menu
	 */
	public userMenu: any[];

	/**
	 * Current user object
	 */
	public user: AuthUser = AuthHelper.user;

	/**
	 * onLogout?: function
	 * Event emitted when a meni logout is clicked.
	 */
	@Output() onLogout: EventEmitter<any> = new EventEmitter<any>();

	/**
	 * Constructor
	 */
	constructor(
		public oidcSecurityService: OidcSecurityService,
		private router: Router,
		private route: ActivatedRoute,
		private titleService: Title
	) {
		/* Listen rou router evenets */
		this.router.events
			.subscribe((event) => {
				/* Rememeber last visitied route */
				if (event instanceof NavigationStart) {
					if (!['id_token', 'code', 'unauthorized', 'forbidden', 'login'].some(x => event.url.includes(x))) {
						localStorage.setItem('routeUrl', event.url);
					}
				}

				/* Set loaded to true to hide loadin indicator */
				if (event instanceof NavigationEnd) {
					this.loaded = true;
				}
			});
	}

	/**
	 * Lifecycle hook that is called after data-bound properties 
	 * of a directive are initialized.
	 */
	ngOnInit() {
		/* Get menu items from route snapshot */
		this.menu = this.route.snapshot.data.menu;

		/* Redirect to post login route */
		if (this.router.url == "/") {
			this.router.navigate([AuthHelper.user.postLoginRoute || environment.postLoginRoute])
		}

		/* Init user menu */
		if (AuthHelper.isAuthenticated()) {
			this.userMenu = [
				{
					event: this.onLogout,
					icon: 'exit_to_app',
					title: 'Ausloggen',
					enabled: true
				}, {
					path: ['/users/edit', AuthHelper.user.id],
					icon: 'account_circle',
					title: 'Profil beabeiten',
					enabled: true
				}, {
					path: ['/users/change-password', AuthHelper.user.id],
					icon: 'vpn_key',
					title: 'Passwort ändern',
					enabled: true
				}, {
					path: ['/users/authenticator-app'],
					icon: 'vpn_key',
					title: 'Authentifizierungs-App',
					enabled: true
				}
			];

			if (AuthHelper.hasRole('ClientManager')) {
				this.userMenu.push({
					path: ['/customers/client/current'],
					icon: 'account_circle',
					title: 'Firmenprofil ändern',
					enabled: true
				});
			}

			/* Subscribe to logout event */
			this.onLogout.subscribe(x => this.oidcSecurityService.logoff());
		}
	}

	/**
	 * Lifecycle hook that is called after a component's view has 
	 * been fully initialized.
	 */
	ngAfterViewInit(): void {
		this.title = this.titleService.getTitle();
	}
}